(function () {

	'use strict';

	/*global $:true */

	let cologicSlide = {


        someCallback: function (args) {
            var currentSlideNumber = args.currentSlideNumber;
            if($('.sliderButton').length>0){
                $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
                $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
                // console.log($(args.currentSlideObject));

            }
        },

        sideImageChange: function (args) {
            console.log(args);
            // args.sliderObject.iosSlider('update');

            // if($('.sliderButton').length>0){
            //     // console.log(args);
            //     $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
            //     $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.targetSlideNumber -1) + ')').addClass('selected');
            //     // $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
            // }
        },


        initGallerySlider: function (_sliderId, gotoHashImgNo=1, _arrowCont) {
            let that = this;
            if ($(_sliderId).length <= 0) return false;
            // if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
            //     gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: false,
                startAtSlide: gotoHashImgNo,
                navPrevSelector: $(_arrowCont+' .prev'),
                navNextSelector: $(_arrowCont+' .next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true

            });
            console.log($(_sliderId +' .prev'));

        },

        initMBBoxSlider: function (_sliderId, gotoHashImgNo, _elemNr) {
            let that = this;
            let sliderButtons = '#sliderButtonContainer-'+ _elemNr + ' .sliderButton';
            $(_sliderId + ' .slide.active').addClass('activeSlide');
            if ($(_sliderId).length <= 0) return false;
            if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
                gotoHashImgNo = 1;
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: true,
                autoSlideTimer: 5000,
                autoSlideTransTimer: 2000,
                startAtSlide: gotoHashImgNo,
                // navSlideSelector: $(sliderButtons),
                navPrevSelector: $('#prev-'+ _elemNr),
                navNextSelector: $('#next-'+ _elemNr),
                onSlideChange: that.someNumberCallback,
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true,
                onSliderLoaded: cologic.sliderLoaded
            });
        },

        initStdSlider: function (_sliderId, gotoHashImgNo, _elemNr) {
            let that = this;
            let sliderButtons = '#sliderButtonContainer-'+ _elemNr + ' .sliderButton';

            if ($(_sliderId).length <= 0) return false;
            if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
                gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: false,
                autoSlideTimer: 12000,
                autoSlideTransTimer: 2000,
                startAtSlide: gotoHashImgNo,
                navSlideSelector: $(sliderButtons),
                navPrevSelector: $('#sliderArrowContainer-'+ _elemNr + ' .prev'),
                navNextSelector: $('#sliderArrowContainer-'+ _elemNr + ' .next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true,
                onSliderResize: cologic.sliderUpdate,
                onSliderLoaded: cologic.sliderLoaded
            });
        },


        initSideImageSlider: function (_sliderId, _elemNr) {
            let that = this;
            // let sliderButtons = '#sliderButtonContainer-'+ _elemNr + ' .sliderButton';
            if ($(_sliderId).length <= 0) return false;
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: false,
                // autoSlideTimer: 5000,
                // autoSlideTransTimer: 1000,
                startAtSlide: 1,
                // navPrevSelector: $('#sliderContainer-' + _elemNr + ' .navButtons .prev'),
                // navNextSelector: $('#sliderContainer-' + _elemNr + ' .navButtons .next'),
                navPrevSelector: $('#prev-'+ _elemNr),
                navNextSelector: $('#next-'+ _elemNr),
                // navSlideSelector: $(sliderButtons),
                infiniteSlider: true,
                responsiveSlideContainer: true,
                responsiveSlides: true,
                // onSlideChange: that.sideImageChange,
                onSliderResize: that.sliderUpdate
            });

        },

        initMBGallerySlider: function (_sliderId, gotoHashImgNo) {
            let that = this;
            if ($(_sliderId).length <= 0) return false;
            if (gotoHashImgNo === undefined || gotoHashImgNo <= 0)
                gotoHashImgNo = 1;
            //console.log("* "+gotoHashImgNo+" *");
            $(_sliderId).iosSlider({
                snapToChildren: true,
                scrollbar: false,
                scrollbarHide: true,
                desktopClickDrag: true,
                autoSlide: true,
                autoSlideTimer: 5000,
                autoSlideTransTimer: 2000,
                startAtSlide: gotoHashImgNo,
                // navPrevSelector: $('.prev'),
                // navNextSelector: $('.next'),
                onSlideChange: that.someCallback,
                infiniteSlider: true,

            });
        },



    initSlider: function(_sliderId, _sliderButton, _arrowCont){
        let that = this;

        // initSlider: function(_sliderId, _sliderButton, _arrowCont){
        $(_sliderId).iosSlider({
            snapToChildren: true,
            scrollbar: false,
            scrollbarDrag: false,
            scrollbarHeight: '15px',
            navSlideSelector: $(_sliderButton),
            navPrevSelector: $(_arrowCont+' .slideLeft'),
            navNextSelector: $(_arrowCont+' .slideRight'),
            autoSlide: true,
            autoSlideTimer: 5000,
            autoSlideTransTimer: 1000,
            desktopClickDrag: true,
            infiniteSlider: true,
            responsiveSlideContainer: true,
            responsiveSlides: true,
            onSlideChange: that.someCallback
            // onSliderResize: cologic.sliderUpdate
        });
    },





        sliderUpdate: function(args) {
            args.sliderObject.iosSlider('update');
    },

    sliderLoaded: function(args) {

    },
    someNumberCallback: function (args) {
        // console.log(args);
        var currentSlideNumber = args.currentSlideNumber;
        if($('.activeSlideNr').length>0){
            $(args.sliderContainerObject).find('.slide').removeClass('activeSlide');
            $(args.currentSlideObject).addClass('activeSlide');

            // $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
            // $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
            $('#sliderButtonContainer-'+args.sliderContainerObject.data('tag-elem-nr')+' .activeSlideNr').html(args.currentSlideNumber);
            // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton').removeClass('selected');
            // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');

        }

    },


    slideChange: function(args) {
        // if($('.sliderButton').length>0){
        //     $('#sliderButtonContainer'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
        //     $('#sliderButtonContainer'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
        //     // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton').removeClass('selected');
        //     // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
        //
        // }
    }




};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSlide);
}());